import { Stack, Button } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import EmailTemplates from 'src/sections/message/sections/email-templates';
import JobApplyLink from './sections/job-apply-link';
import PostOnLinkedin from './sections/post-on-linkedin';

export default function Launch() {
  // hooks
  const router = useRouter();

  return (
    <Stack spacing={4} width="80%">
      <JobApplyLink />
      {/* <EnrichApplication /> */}
      {/* <UploadResume /> */}
      <PostOnLinkedin />
      <EmailTemplates showTemplatesList={['APPLICATION', 'SHORTLISTED']} />
      <Button
        variant="soft"
        sx={{
          color: theme => theme.palette.content.primaryBlack1,
          bgcolor: theme => theme.palette.background.primaryAccent2,
          '&:hover': {
            color: theme => theme.palette.content.primaryWhite,
            bgcolor: theme => theme.palette.background.primaryAccent1,
          },
        }}
        onClick={() => router.push(paths.dashboard.jobs.root)}
        endIcon={<Iconify icon="tabler:chevron-right" />}
      >
        Go to dashboard (Job details)
      </Button>
    </Stack>
  );
}
